module.exports = __webpack_public_path__ + "img/connect-3.8810fd60.svg";